import {CompositeDeviceConnectProvide, DeviceConnectProvide} from "@hybird/core/device/connect";
import {DeviceProtocol} from "@hybird/core/device/protocol";
import {defaultError, WebError} from "@hybird/core/error";

class DeviceProvide {
  /**
   *
   * @type {DeviceConnectProvide}
   */
  _deviceConnectProvide;

  _deviceProtocols = {}

  get deviceConnectProvide() {
    return this._deviceConnectProvide;
  }

  /**
   * @param deviceInfo{DeviceInfo}
   * @return {Class<DeviceProtocol>}
   * @constructor
   */
  getDeviceProtocol(deviceInfo) {
    if (deviceInfo.property) {
      return this._deviceProtocols[2];
    }

    const compositeDeviceProtocol = this._deviceProtocols[3];

    if (compositeDeviceProtocol) {
      return compositeDeviceProtocol;
    }

    for (const connectType in this._deviceProtocols) {
      if (deviceInfo.connectType === parseInt(connectType)) {
        return this._deviceProtocols[connectType];
      }
    }
  }

  /**
   *
   * @param deviceConnectProvide{DeviceConnectProvide}
   */
  constructor(deviceConnectProvide) {
    if (new.target === DeviceProvide) {
      throw WebError.code(defaultError.NOT_CONSTRUCTOR);
    }

    this._deviceConnectProvide = deviceConnectProvide;
  }

  async connect(deviceInfo, {
    connectType,
    onConnect, onConnected, onReconnect, onError,
    onDisconnect,
    onDisconnected, timeout, config
  } = {}) {
    if (deviceInfo == null) {
      throw WebError.code(defaultError.ILLEGAL_ARGUMENT, {
        msg: "连接参数异常"
      });
    }

    if (this._deviceConnectProvide instanceof CompositeDeviceConnectProvide) {
      await this._deviceConnectProvide.setConnectType(connectType);
    }

    if (!this._deviceConnectProvide.connected) {
      return this._deviceConnectProvide.connect({
        onConnect, onConnected, onReconnect, onError,
        onDisconnect,
        onDisconnected, timeout, config
      });
    }
  }

  disconnect() {
    return this._deviceConnectProvide.disconnect();
  }

  /**
   * @type{boolean}
   */
  isSupport(deviceInfo) {
    return false;
  }
}

class CompositeDeviceProvide extends DeviceProvide {
  /**
   * @type{Array<Class<DeviceProvide>>}
   */
  static deviceProvides = [];

  /**
   * @type{Array<DeviceProvide>}
   */
  _deviceProvides;

  /**
   * @type{Map<DeviceInfo, DeviceProvide>}
   */
  _deviceProvidesInstance = {};

  isSupport(deviceInfo) {
    for (const i in this._deviceProvides) {
      if (this._deviceProvides[i].isSupport(deviceInfo)) {
        return true;
      }
    }

    return false;
  }

  constructor({
                deviceProvides = CompositeDeviceProvide.deviceProvides,
                deviceConnectProvide = new CompositeDeviceConnectProvide()
              } = {}) {
    super(deviceConnectProvide);

    this._deviceConnectProvide = deviceConnectProvide;
    this._deviceProvides = deviceProvides.map(deviceProvide => new deviceProvide(this._deviceConnectProvide));
  }

  getDeviceProtocol(deviceInfo) {
    const deviceProvide = this._deviceProvides.find(deviceProvide => deviceProvide.isSupport(deviceInfo));
    const deviceProtocol = deviceProvide.getDeviceProtocol(deviceInfo);

    if (deviceProvide && deviceProtocol) {
      return this._deviceProvidesInstance[deviceInfo.number] = deviceProtocol;
    } else {
      throw WebError.code(defaultError.CONNECT_NOT_SUPPORT);
    }
  }

  /**
   * @param deviceProvide{Class<DeviceProvide | DeviceConnectProvide>}
   */
  static register(deviceProvide) {
    if (Object.prototype.isPrototypeOf.call(DeviceConnectProvide, deviceProvide)) {
      CompositeDeviceProvide.deviceProvides.push(deviceProvide);
    } else if (Object.prototype.isPrototypeOf.call(DeviceProvide, deviceProvide)) {
      CompositeDeviceProvide.deviceProvides.push(deviceProvide);
    }
  }

  /**
   * @param deviceProvide{Class<DeviceProvide>}
   */
  static unRegister(deviceProvide) {
    CompositeDeviceProvide.deviceProvides = CompositeDeviceProvide.deviceProvides.filter(_deviceProvide => _deviceProvide !== deviceProvide);
  }
}


export {DeviceProvide, CompositeDeviceProvide};